import React from 'react';
import styled from 'styled-components';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import gql from 'graphql-tag';
import { useQuery, useMutation } from '@apollo/react-hooks';

import Block from 'components/common/block';
import { ReactComponent as TrashIcon } from 'assets/vectors/remove-16px.svg';
import { ReactComponent as AddIcon } from 'assets/vectors/add-green-16px.svg';
import { ReactComponent as MiscIcon } from 'assets/vectors/miscIcon.svg';

import MiscellaniesModal from './miscellaniesModal';

const ArchiveStsProjectEquipment = gql`
  mutation ArchiveStsProjectEquipment($input: ArchiveStsProjectEquipmentInput!) {
    archiveStsProjectEquipment(archiveStsProjectEquipmentData: $input) {
      success
    }
  }
`;

const GetMiscellanies = gql`
  query StsProjectEquipments ($sortBy: [String], $stsprojectId: ID){
    stsprojectEquipments(sortBy: $sortBy, stsprojectId: $stsprojectId) {
      edges {
        node {
          id
          miscellany {
            id
            plNumber
            location
            contents
          }
        }
      }
    }
  }
`;

function Miscellanies({ projectId, onAdd, allowEdit }) {
  const [showMiscellaniesModal, setShowMiscellaniesModal] = React.useState(false);

  const {data, refetch} = useQuery(GetMiscellanies, {
    variables: {
      stsprojectId: projectId,
      sortBy: ['created desc']
    },
    onError(e) {
      console.log(e);
    }
  });

  const [executeArchiveStsProjectEquipment, { loading: archiveLoading }] = useMutation(ArchiveStsProjectEquipment, {
    onCompleted() {
      refetch();
    }
  });

  function addMiscellany() {
    setShowMiscellaniesModal(true);
  }

  function removeMiscellany(equipmentId) {
    executeArchiveStsProjectEquipment({
      variables: {
        input: {
          stsprojectEquipmentId: equipmentId,
        }
      }
    })
  }

  const projectEquipments = data ? data.stsprojectEquipments.edges.map(r => r.node).filter(r => !!r.miscellany) : [];
  const addedMiscellanies = projectEquipments.map(r => r.miscellany.id);

  return (
    <StyledBlock title={<BlockTitle><MiscIcon style={{ marginRight: '8px'}} /> Miscellaneous</BlockTitle>}>
      <TableContainer>
        <Table aria-label="simple table" style={{ whiteSpace: 'nowrap' }}>
          <TableHead>
            <TableRow>
              <TableCell>
                PL Nr.
              </TableCell>
              <TableCell>
                Location
              </TableCell>
              <TableCell>
                Contents
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
          {
              !projectEquipments.length
                ? <TableRow>
                    <TableCell>None added</TableCell>
                    <TableCell />
                    <TableCell />
                    <TableCell />
                  </TableRow>
                : (
                  projectEquipments.map(equipment => (
                    <TableRow key={equipment.id}>
                      <TableCell>
                        <Link href={`/dashboard/equipment/miscellaneous/${equipment.miscellany.id}`} target="_blank">{equipment.miscellany.plNumber}</Link>
                      </TableCell>
                      <TableCell>
                        {equipment.miscellany.location}
                      </TableCell>
                      <TableCell style={{ maxWidth: '300px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                        {equipment.miscellany.contents}
                      </TableCell>
                      <TableCell align="right">
                        {
                          allowEdit && (
                            <IconButton
                              onClick={() => removeMiscellany(equipment.id)}
                              aria-label="delete miscellaneous"
                              className="deleteButton"
                              disabled={archiveLoading}
                            >
                              <TrashIcon />
                            </IconButton>
                          )
                        }
                      </TableCell>
                    </TableRow>
                  ))
                )
            }
          </TableBody>
        </Table>
      </TableContainer>
      {
        allowEdit && (
          <ButtonWrapper>
            <Button
              variant="outlined"
              color="primary"
              onClick={addMiscellany}
              endIcon={<AddIcon />}
            >
            Add Miscellaneous
            </Button>
          </ButtonWrapper>
        )
      }
      { showMiscellaniesModal && <MiscellaniesModal setShowMiscellaniesModal={setShowMiscellaniesModal} projectId={projectId} refetch={refetch} addedMiscellanies={addedMiscellanies} onAdd={onAdd} /> }
    </StyledBlock>
  );
}

const BlockTitle = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.textColor};
`;

const StyledBlock = styled(Block)`
  width: 1080px;
  max-width: 100%;
  margin-bottom: 16px;
`;

const Link = styled.a`
  color: ${props => props.theme.colors.primaryColor};
  text-decoration: none;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;

  @media (${props => props.theme.breakpoints.tablet}) {
    justify-content: flex-start;
  }
`;

export default Miscellanies;
